/** MediaRecorder обычно отдаёт WebM. Общий audio-upload принимает WAV: перекодируем настоящую запись локально. */
export async function recordingWav(file: File, maxDurationMs: number): Promise<File> {
  const decoder = new OfflineAudioContext(1, 1, 16000);
  const decoded = await decoder.decodeAudioData(await file.arrayBuffer());
  if (!Number.isFinite(decoded.duration) || decoded.duration <= 0 || decoded.duration * 1000 > maxDurationMs + 250)
    throw new Error('Запись слишком длинная или не читается.');
  const renderer = new OfflineAudioContext(1, Math.ceil(decoded.duration * 16000), 16000);
  const source = renderer.createBufferSource(); source.buffer = decoded; source.connect(renderer.destination); source.start();
  const rendered = await renderer.startRendering();
  return pcmWav(rendered.getChannelData(0), 16000, file.name.replace(/\.[^.]+$/, '.wav'));
}

export function pcmWav(samples: Float32Array, rate: number, name: string): File {
  const bytes = new ArrayBuffer(44 + samples.length * 2), view = new DataView(bytes);
  const text = (offset: number, value: string) => [...value].forEach((char, index) => view.setUint8(offset + index, char.charCodeAt(0)));
  text(0, 'RIFF'); view.setUint32(4, bytes.byteLength - 8, true); text(8, 'WAVEfmt ');
  view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
  view.setUint32(24, rate, true); view.setUint32(28, rate * 2, true); view.setUint16(32, 2, true);
  view.setUint16(34, 16, true); text(36, 'data'); view.setUint32(40, samples.length * 2, true);
  samples.forEach((sample, index) => view.setInt16(44 + index * 2, Math.round(Math.max(-1, Math.min(1, sample)) * (sample < 0 ? 32768 : 32767)), true));
  return new File([bytes], name, { type: 'audio/wav' });
}
